export enum GeneratePdfContentType {
  LEARNING_PATH = 'LEARNING_PATH',
  COURSE = 'COURSE',
  ARCHIVED_CONTENT = 'ARCHIVED_CONTENT',
}
